import React from 'react';
import { Tag, Tooltip } from 'antd';

import { FUNNEL } from '../icons';
import { isDynamicGroup } from '../../utils/dynamicGroups';

export const DYNAMIC_GROUP_HINT = "Membership follows the group's rule";

/**
 * The kind chip a group wears wherever it is named — the Sharing tab's rows
 * and pickers, the audience audit, the Who can see this window. A static group
 * wears nothing: the list of people IS the group, and a chip saying so would
 * be noise on every row that existed before rules did. A dynamic group's
 * chip carries the hover that explains why its members are not editable.
 */
export default function GroupKindTag({ group, kind, tooltip = true, className }) {
	const dynamic = kind ? kind === 'dynamic' : isDynamicGroup(group);
	if (!dynamic) return null;
	const tag = (
		<Tag className={['group-kind-tag', className].filter(Boolean).join(' ')} icon={<FUNNEL />}>
			Dynamic
		</Tag>
	);
	return tooltip ? <Tooltip title={DYNAMIC_GROUP_HINT}>{tag}</Tooltip> : tag;
}
